import { PhosphorColor, hashString, memoFn } from "@phosphor/utils";
import { weakMemoFn } from "@phosphor/utils";
import { getColorStyles } from "#scripts/lib/hooks/useColorStyles.ts";
import type { Color } from "../types/Color.ts";

/** so the objject references are kept the same across renders */
const colorForHue = memoFn((hue: number) => PhosphorColor.make({ hue, chroma: 0.1 }));

/** Get a color (PhosphorColor) for a string using a basic hashing function */
export function getColorForString(str: string) {
  return colorForHue(hashString(str) % 360);
}

// A small cache of color styles for primitive type names or string values
const hashColorStylesMemo = memoFn((str: string) => getColorStyles(getColorForString(str)));
const colorStylesMemo = weakMemoFn(getColorStyles);

export const getColorFor = (nameOrColor: string | Color) => {
  if (typeof nameOrColor === "string") {
    return hashColorStylesMemo(nameOrColor);
  } else {
    return colorStylesMemo(nameOrColor);
  }
};
